/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Address_PlaceholderInputs */

const en_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

const id_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat surel`)
};

const ms_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat e-mel`)
};

const ca_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adreça electrònica`)
};

const cs_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailová adresa`)
};

const da_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mailadresse`)
};

const de_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse`)
};

const et_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posti aadress`)
};

const es_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirección de correo electrónico`)
};

const fr_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse e-mail`)
};

const hr_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-adresa`)
};

const it_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indirizzo email`)
};

const lv_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-pasta adrese`)
};

const lt_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El. pašto adresas`)
};

const hu_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail cím`)
};

const nl_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailadres`)
};

const nb_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-postadresse`)
};

const pl_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adres e-mail`)
};

const pt_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereço de e-mail`)
};

const ro_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresă de e-mail`)
};

const sk_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailová adresa`)
};

const sl_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-poštni naslov`)
};

const fi_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sähköpostiosoite`)
};

const sv_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-postadress`)
};

const vi_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ email`)
};

const tr_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta adresi`)
};

const el_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διεύθυνση ηλεκτρονικού ταχυδρομείου`)
};

const bg_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имейл адрес`)
};

const ru_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес электронной почты`)
};

const sr_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имејл адреса`)
};

const uk_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Електронна адреса`)
};

const ka_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ელფოსტა`)
};

const hi_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल पता`)
};

const th_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่อยู่อีเมล`)
};

const ko_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소`)
};

const zh_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮件地址`)
};

const zh_tw_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子郵件地址`)
};

const ja_email_address_placeholder = /** @type {(inputs: Email_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メール アドレス`)
};

/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Email_Address_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const email_address_placeholder = /** @type {((inputs?: Email_Address_PlaceholderInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Address_PlaceholderInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_email_address_placeholder(inputs)
	if (locale === "ms") return ms_email_address_placeholder(inputs)
	if (locale === "ca") return ca_email_address_placeholder(inputs)
	if (locale === "cs") return cs_email_address_placeholder(inputs)
	if (locale === "da") return da_email_address_placeholder(inputs)
	if (locale === "de") return de_email_address_placeholder(inputs)
	if (locale === "et") return et_email_address_placeholder(inputs)
	if (locale === "es") return es_email_address_placeholder(inputs)
	if (locale === "fr") return fr_email_address_placeholder(inputs)
	if (locale === "hr") return hr_email_address_placeholder(inputs)
	if (locale === "it") return it_email_address_placeholder(inputs)
	if (locale === "lv") return lv_email_address_placeholder(inputs)
	if (locale === "lt") return lt_email_address_placeholder(inputs)
	if (locale === "hu") return hu_email_address_placeholder(inputs)
	if (locale === "nl") return nl_email_address_placeholder(inputs)
	if (locale === "nb") return nb_email_address_placeholder(inputs)
	if (locale === "pl") return pl_email_address_placeholder(inputs)
	if (locale === "pt") return pt_email_address_placeholder(inputs)
	if (locale === "ro") return ro_email_address_placeholder(inputs)
	if (locale === "sk") return sk_email_address_placeholder(inputs)
	if (locale === "sl") return sl_email_address_placeholder(inputs)
	if (locale === "fi") return fi_email_address_placeholder(inputs)
	if (locale === "sv") return sv_email_address_placeholder(inputs)
	if (locale === "vi") return vi_email_address_placeholder(inputs)
	if (locale === "tr") return tr_email_address_placeholder(inputs)
	if (locale === "el") return el_email_address_placeholder(inputs)
	if (locale === "bg") return bg_email_address_placeholder(inputs)
	if (locale === "ru") return ru_email_address_placeholder(inputs)
	if (locale === "sr") return sr_email_address_placeholder(inputs)
	if (locale === "uk") return uk_email_address_placeholder(inputs)
	if (locale === "ka") return ka_email_address_placeholder(inputs)
	if (locale === "hi") return hi_email_address_placeholder(inputs)
	if (locale === "th") return th_email_address_placeholder(inputs)
	if (locale === "ko") return ko_email_address_placeholder(inputs)
	if (locale === "zh") return zh_email_address_placeholder(inputs)
	if (locale === "zh-tw") return zh_tw_email_address_placeholder(inputs)
	if (locale === "ja") return ja_email_address_placeholder(inputs)
	return en_email_address_placeholder(inputs)
});